import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-banners-forms',
  templateUrl: './add-banners-forms.component.html',
  styleUrls: ['./add-banners-forms.component.css']
})
export class AddBannersFormsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
